const callNoteModes = {
    CALL: "Call",
    NOTE: "Note",
};

export default callNoteModes;
